export default __webpack_public_path__ + "images/icons/arrow-bottom-9e4aba7fa703cb687d3d7178dc71e45e.svg";